<template lang="pug">
    .cadastro-lote-detalhes
        BaseHeader(
            :titulo="$t('mensagens.operacoesLoteDetalhes.titulo')"
            :exibeBotao="true"
            icon="el-icon-back"
            :btnTexto="$t('mensagens.comuns.voltar')"
            @btnHeaderClicado="voltar"
        )

        .view-container-base-header
            div(v-loading="loading")
                el-table(
                    :data="detalhes"
                    style="width: 100%"
                    row-key="id"
                    border
                    :expand-row-keys="expandRowKeys"
                    @expand-change="handleExpandChange"
                )
                    el-table-column(type="expand")
                        template(slot-scope="props")
                            .detalhes-container
                                .row
                                    .col-md-6
                                        h5 Pessoas
                                        el-table(:data="props.row.pessoas" border size="mini")
                                            el-table-column(prop="nome" label="Nome")
                                            el-table-column(prop="cpfCnpjDecrypt" label="CPF/CNPJ")
                                            el-table-column(prop="papel" label="Papel")
                                            el-table-column(label="Status" align="center")
                                                template(slot-scope="scope")
                                                    el-tag(size="mini" :type="scope.row.jaExistia ? 'info' : 'success'")
                                                        | {{ scope.row.jaExistia ? 'Existente' : 'Novo' }}
                                    
                                    .col-md-6
                                        h5 Territórios
                                        el-table(:data="props.row.territorios" border size="mini")
                                            el-table-column(prop="codigoCar" label="CAR")
                                            el-table-column(prop="nome" label="Nome")
                                            el-table-column(prop="tipoGleba" label="Tipo Gleba")
                                            el-table-column(label="Status" align="center")
                                                template(slot-scope="scope")
                                                    el-tag(size="mini" :type="scope.row.jaExistia ? 'info' : 'success'")
                                                        | {{ scope.row.jaExistia ? 'Existente' : 'Novo' }}

                    el-table-column(prop="identificadorOperacao" label="Identificador")
                    el-table-column(prop="nomeOperacao" label="Nome Operação")
                    el-table-column(prop="categoria" label="Categoria")
                    el-table-column(prop="status" label="Status" align="center")
                        template(slot-scope="scope")
                            el-tag(:type="getStatusType(scope.row.status)") {{ scope.row.status }}
                    
                    el-table-column(label="Mensagem" min-width="200")
                        template(slot-scope="scope")
                            span(v-if="scope.row.status === 'ERRO'" class="text-danger") {{ scope.row.mensagemErro }}
                            span(v-else) -

</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import OperacaoService from '@/services/OperacaoService';

export default {
    name: 'CadastroLoteDetalhes',
    components: {
        BaseHeader
    },
    data() {
        return {
            loading: false,
            detalhes: [],
            expandRowKeys: []
        };
    },
    created() {
        this.carregarDetalhes();
    },
    methods: {
        async carregarDetalhes() {
            try {
                this.loading = true;
                const id = this.$route.params.id;
                const response = await OperacaoService.listarDetalhesCadastroLote(id);
                this.detalhes = response.data;
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao carregar detalhes.'
                });
            } finally {
                this.loading = false;
            }
        },
        voltar() {
            this.$router.push('/operacao/lote');
        },
        getStatusType(status) {
            return status === 'PROCESSADO' ? 'success' : 'danger';
        },
        handleExpandChange(row, expandedRows) {
            // Optional: logic to handle expansion
        }
    }
};
</script>

<style scoped lang="scss">
.view-container-base-header {
    padding: 20px;
    background-color: white;
    border-radius: 5px;
}
.detalhes-container {
    padding: 10px;
    background-color: #f9f9f9;
}
.text-danger {
    color: #F56C6C;
}
</style>
